(() => {
  const sale = document.querySelector('[data-rdr-summer-sale]');
  if (!sale) return;

  const storageKey = 'rdr-summer-sale-collapsed';
  const toggle = sale.querySelector('[data-rdr-sale-toggle]');
  const units = {
    days: sale.querySelector('[data-rdr-sale-days]'),
    hours: sale.querySelector('[data-rdr-sale-hours]'),
    minutes: sale.querySelector('[data-rdr-sale-minutes]'),
    seconds: sale.querySelector('[data-rdr-sale-seconds]'),
  };

  const setCollapsed = (collapsed) => {
    sale.classList.toggle('is-collapsed', collapsed);
    toggle.setAttribute('aria-expanded', String(!collapsed));
    toggle.setAttribute('aria-label', collapsed ? toggle.dataset.expandLabel : toggle.dataset.collapseLabel);
    localStorage.setItem(storageKey, String(collapsed));
  };

  if (localStorage.getItem(storageKey) === 'true') setCollapsed(true);
  toggle.addEventListener('click', () => setCollapsed(!sale.classList.contains('is-collapsed')));

  const getDeadline = () => {
    const now = new Date();
    const deadline = new Date(now);
    const daysUntilNextSunday = now.getDay() === 0 ? 7 : 7 - now.getDay();
    deadline.setDate(now.getDate() + daysUntilNextSunday);
    deadline.setHours(23, 59, 0, 0);
    return deadline;
  };

  const deadline = getDeadline();
  const updateCountdown = () => {
    const remaining = Math.max(0, deadline.getTime() - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    units.days.textContent = String(days).padStart(2, '0');
    units.hours.textContent = String(hours).padStart(2, '0');
    units.minutes.textContent = String(minutes).padStart(2, '0');
    units.seconds.textContent = String(seconds).padStart(2, '0');
  };

  updateCountdown();
  window.setInterval(updateCountdown, 1000);
})();
